import { ENVIRONMENT } from './environment';

export interface MixpanelConfigProps {
    token: string;
    debug: boolean;
}

export const mixpanelConfigProd: MixpanelConfigProps = {
    token: 'cbeb8c64d33711506471a1b7a7147862',
    debug: false,
};

export const mixpanelConfigDev: MixpanelConfigProps = {
    token: 'da460ed08b252abaad0abbdcef620c60',
    debug: true,
};

const mixpanel = ENVIRONMENT === 'production' ? mixpanelConfigProd : mixpanelConfigDev;

export default mixpanel;
